<template>
	<div>
		<md-button class="md-icon-button left" @click="setType('deferred')">
			<md-icon class="icon" :class="isDeferred">alarm</md-icon>
		</md-button>
		<md-button class="md-icon-button" @click="setType('inbox')">
			<md-icon class="icon" :class="isInbox">inbox</md-icon>
		</md-button>
		<md-button class="md-icon-button" @click="setType('done')">
			<md-icon class="icon" :class="isDone">done</md-icon>
		</md-button>
		<md-button class="md-icon-button right" @click="setType('trash')">
			<md-icon class="icon">delete</md-icon>
		</md-button>
	</div>
</template>
<script>
export default {
	name: 'TabFilterBtn',
	props: {
		body: {
			type: Object,
			required: true
		}
	},
	methods: {
		setType: function (to) {
			this.$store.dispatch('tabs/setType', {id: this.body.id, to: to})
		}
	},
	computed: {
		isDeferred: function () {
			return this.body.type === 'deferred' ? 'deferred' : ''
		},
		isInbox: function () {
			return this.body.type === 'inbox' ? 'inbox' : ''
		},
		isDone: function () {
			return this.body.type === 'done' ? 'done' : ''
		}
	}
}
</script>
<style scoped>
.deferred {
	color: #FFA500 !important;
}
.inbox {
	color: #6EBD91 !important;
}
.done {
	color: #1E2D47 !important;
}
.icon {
	min-width: 20px !important;
	font-size: 20px !important;
	color: gray;
}
.left {
	padding-left: 0px;
	margin-left: 0px;
}
.md-icon-button {
	height: 26px !important;
	min-width: 26px !important;
	width: 26px !important;
	margin-right: 20px;
}
.right {
	height: 26px !important;
	min-width: 26px !important;
	width: 26px !important;
	margin-right: 6px;
}
</style>
